var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgStackedArea = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "30px",
    viewBox: "0 0 40 30",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "background",
    stroke: "#CCCCCC",
    fill: "#FFFFFF",
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 29,
    rx: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    transform: "scale(0.23, 0.20)",
    fill: "#37809f",
    d: "m128 118h-88v-21.301l29.5-19.602 30.102 9.8008 28.398-19.598v50.699m-28.301-40.898l28.301-19.602v-29.398l-28.301 9.8008-29.598 19.598-30.102 9.8008v19.602l30.102-19.602z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgStackedArea);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/stacked_area.666d9c0a46bb142c4bd7b542161f1ef5.svg";